const ProfileInputItem = ({ label, desc, children, isLast = false, error, rightElement }) => {
  return (
    <div className='w-full'>
      <div className='flex justify-between items-center mt-3'>
        <div className='text-dark font-medium text-base'>{label}</div>
        {rightElement}
      </div>
      <div className='text-[#6c6c89] text-base'>{desc}</div>
      <div className=' mt-2'>{children}</div>
      {error && <p className='mt-2 text-sm text-red-600'>{error}</p>}
    </div>
  );
};

export default ProfileInputItem;
